const SCALE = 2;

function inlineStyles(source: Element, copy: Element) {
  const style = getComputedStyle(source);
  copy.setAttribute('style', Array.from(style, (name) => `${name}:${style.getPropertyValue(name)}`).join(';'));
  Array.from(source.children).forEach((child, index) => inlineStyles(child, copy.children[index]));
}

export async function blockPng(node: HTMLElement, background: string, leaveOut: string): Promise<string> {
  const { width, height } = node.getBoundingClientRect();
  const copy = node.cloneNode(true) as HTMLElement;
  inlineStyles(node, copy);
  copy.querySelectorAll(leaveOut).forEach((element) => element.remove());
  copy.style.margin = '0';
  copy.style.outline = 'none';
  const markup = new XMLSerializer().serializeToString(copy);
  const image = new Image();
  image.src = `data:image/svg+xml;charset=utf-8,${encodeURIComponent(`<svg xmlns="http://www.w3.org/2000/svg" width="${width}" height="${height}"><foreignObject width="100%" height="100%">${markup}</foreignObject></svg>`)}`;
  await image.decode();
  const canvas = document.createElement('canvas');
  canvas.width = Math.ceil(width * SCALE);
  canvas.height = Math.ceil(height * SCALE);
  const drawing = canvas.getContext('2d')!;
  drawing.scale(SCALE, SCALE);
  drawing.fillStyle = background;
  drawing.fillRect(0, 0, width, height);
  drawing.drawImage(image, 0, 0, width, height);
  return canvas.toDataURL('image/png');
}
